export * from './auth.guard';



// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/guard/index.ts